// A chart's predicted periods, as its query returns them: shared by the
// Highcharts and ECharts forecasts

export interface ForecastPoint {
  // The predicted bucket's date, as the chart's own rows give it
  date: string;
  avg: number;
  // The 95% range
  low: number;
  high: number;
}

type PredictedRange = { lower?: number; upper?: number };

// A metric's predicted buckets, from the rows its query appended (see
// aggregateCompoundMetric's forecastPeriods): { date, predicted: true,
// <metricId>: value, forecast: { <metricId>: { lower, upper } } }. A metric
// with too little history has none.
export const toForecastPoints = ({
  predicted,
  metricId,
}: {
  predicted: MetricsResponse;
  metricId: string;
}): ForecastPoint[] =>
  predicted.flatMap((row) => {
    const value = row[metricId];
    const ranges = row.forecast as Record<string, PredictedRange> | undefined;
    const range = ranges ? ranges[metricId] : undefined;
    if (
      typeof value !== 'number' ||
      !range ||
      typeof range.lower !== 'number' ||
      typeof range.upper !== 'number'
    ) {
      return [];
    }
    return [
      {
        date: String(row.date),
        avg: value,
        low: range.lower,
        high: range.upper,
      },
    ];
  });
